import React, { useState } from "react";
import Link from "@material-ui/core/Link";
import {
  Checkbox,
  CssBaseline,
  FormControlLabel,
  Button,
  // Container,
  // Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AuthService from "../services/AuthService";
import "./LoginStyle.css";
import { ReactComponent as LogoLoginIcon } from "../static/images/SVGs/logoLogin.svg";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import { useAppContext } from "../services/authContext";

// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       {"cpyright © "}
//       <Link color="inherit" href="http://medinetwork.surge.sh">
//         Medinetwork
//       </Link>{" "}
//       {new Date().getFullYear()}
//       {"."}
//     </Typography>
//   );
// }

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default function ForgetPW(props) {
  const { displayMessage, displayAlert } = useAppContext();
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [details, setDetails] = useState({
    email: "",
  });

  const [values, setValues] = React.useState({
    password: "",
    showPassword: false,
  });

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    AuthService.forgetpw({ email: details.email, roleId: "3" }).then(
      (response) => {
        displayMessage(
          "You request has been sent successfully. The page is going to be redirect to change password page."
        );
        setTimeout(() => {
          props.history.push("/resetpw");
        }, 2000);
      },
      (error) => console.log(error)
    );
  };

  return (
    <div className="login-container">
      <CssBaseline />
      <div className="left-side d-none d-sm-block">
        <div className="icon-line">
          <LogoLoginIcon />
        </div>
        <div className="image-content">
          <img src="/assets/images/loginContent.svg" alt="login content" />
        </div>
      </div>
      <div className="right-side">
        <div className="paper">
          {/* <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar> */}
          {/* <Typography component="h1" variant="h5">
            Sign in 
          </Typography> */}
          <form className="form" noValidate onSubmit={handleSubmit}>
            <div className="form-title">Reset your Password</div>
            <Input
              required
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              placeholder="Email Address"
              autoFocus
              onChange={handleChange}
            />
            {/* <TextField
              variant="filled"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={handleChange}
            /> */}
            {/* <TextField
              variant="filled"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={handleChange}
            /> */}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              className="submit"
            >
              Reset
            </Button>
            {/* <div className="sign-up">
              <Link href="#" variant="body2">
                <span className="sign-up-label">Don't have an account?</span>
                <span className="sign-up-link">Sign Up</span>
              </Link>
            </div> */}
            {/* <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid> */}
          </form>
        </div>
      </div>
      {/* <Box mt={8}>
        <Copyright />
      </Box> */}
    </div>
  );
}
